import { dew as _inherit2Dew } from "../utils/inherit.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = inheritTrailingComments;
  var _inherit = _inherit2Dew();
  function inheritTrailingComments(child, parent) {
    (0, _inherit.default)("trailingComments", child, parent);
  }

  //# sourceMappingURL=inheritTrailingComments.js.map
  return exports;
}